module.exports = __webpack_public_path__ + "img/6eb008e817ba7f7bee6a75f6b7a90f9c.svg";